import ListItem from '@tiptap/extension-list-item';
export type StyleAttrHandler = {
	default: string | null;
	parseHTML: (element: HTMLElement) => Record<string, string>;
	renderHTML: (attributes: Record<string, any>) => Record<string, string>;
};
function createStyleAttrHandler(attributeProp: string, style: string, defaultValue?: string): StyleAttrHandler {
	return {
		default: defaultValue ?? null,
		parseHTML: element => {
			return {
				[attributeProp]: element.style[attributeProp]
			};
		},
		renderHTML: attributes => {
			if (!attributes[attributeProp]) {
				return {};
			}
			return {
				style: `${style}: ${attributes[attributeProp]}`
			};
		}
	};
}
export const CustomListItem = ListItem.extend({
	addAttributes() {
		return {
			color: createStyleAttrHandler('color', 'color'),
			fontFamily: createStyleAttrHandler('fontFamily', 'font-family', 'Arial, sans-serif'),
			fontSize: createStyleAttrHandler('fontSize', 'font-size', `14px`)
		};
	}
});
